import { lazy } from 'react'

import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'

export const RepLoadRoutes = [
  {
    nameUrl: 'Representantes',
    path: urlRoutes.private.representatives.load.url,
    element: lazy(() => import('presentation/pages/representativesLoad')),
    rols: ['*'],
  },
  {
    nameUrl: 'Representantes / Administrar',
    path: urlRoutes.private.representatives.admin.url,
    element: lazy(() => import('presentation/pages/representativeAdministrationLoad')),
    rols: ['*'],
  },
  {
    nameUrl: 'Representantes / Administrar/ Verificacion Datos',
    path: urlRoutes.private.representatives.dataVerification.url,
    element: lazy(() => import('presentation/pages/dataVerification')),
    rols: ['*'],
  },
]
